/**
 * Plain constants shared by client, admin and server.
 *
 * Kept free of typebox imports so the browser clients can use them without
 * pulling the schema builders (and their BigInt usage) into the bundle.
 */
export const MAX_LENGTH = 256;
/**
 * The per-user limits the automatic rate limit moves between, from loosest
 * to strictest. Each level lets a user send about a quarter to a third
 * fewer messages a minute than the one before. It stops at one message per
 * 4 minutes: stricter than that is no longer a chat, and on 2026-10-24 even
 * one message per person for the whole show would have kept the chat at
 * about 300 a minute while the crowd arrived. The admin offers each of them
 * as a preset too.
 */
export const RATE_LIMIT_LEVELS = [
    { maxPoints: 4, duration: 15 },
    { maxPoints: 3, duration: 15 },
    { maxPoints: 2, duration: 15 },
    { maxPoints: 2, duration: 20 },
    { maxPoints: 2, duration: 30 },
    { maxPoints: 1, duration: 20 },
    { maxPoints: 1, duration: 30 },
    { maxPoints: 1, duration: 40 },
    { maxPoints: 1, duration: 50 },
    { maxPoints: 1, duration: 60 },
    { maxPoints: 1, duration: 75 },
    { maxPoints: 1, duration: 90 },
    { maxPoints: 1, duration: 120 },
    { maxPoints: 1, duration: 150 },
    { maxPoints: 1, duration: 180 },
    { maxPoints: 1, duration: 240 },
];
//# sourceMappingURL=constants.js.map